import React from "react";
import { FinancialDocumentExtended } from "@common/types/financialDocument";
import styles from "./FinancialDocumentMatches.module.scss";
import { FinancialJournalEntryLink } from "./FinancialJournalEntryLink";

interface Props {
    financialDocument: FinancialDocumentExtended;
}

export const FinancialDocumentJournalEntries: React.FC<Props> = ({
    financialDocument,
}) => {
    const { linkedJournalEntries } = financialDocument;

    if (linkedJournalEntries.length === 0) {
        return null;
    }

    return (
        <section
            className={styles.list}
            data-testid="financial-document-journal-entries"
        >
            {linkedJournalEntries.map((linkedJournalEntry) => (
                <FinancialJournalEntryLink
                    key={linkedJournalEntry.referenceNumber}
                    linkedJournalEntry={linkedJournalEntry}
                />
            ))}
        </section>
    );
};
